module.exports = __webpack_public_path__ + "static/favicon-a96efd26de79f4e6bfe1466eb842d3a1.ico";